import React from "react";
import type { ExpandedStore } from "./useExpandedStore.js";

export function useEnrichExpandedStoreWithParentPathIds<
  I extends { id: string; pathForPdf: string },
>(
  expandedStore: ExpandedStore,
  items: I[],
  selectedItemId: string | null,
  ready: boolean
) {
  const checked = React.useRef<boolean>(false);
  React.useEffect(() => {
    if (ready && !checked.current) {
      // we check only once after loading is done
      checked.current = true;
      if (selectedItemId) {
        const item = items.find(i => i.id === selectedItemId);
        if (item) {
          const itemParentPathIds = items
            .filter(
              i => item.pathForPdf.startsWith(i.pathForPdf) && i.id !== item.id
            )
            .map(i => i.id);
          if (itemParentPathIds.some(id => !expandedStore.isItemExpanded(id))) {
            // not all parent path item ids are expanded - need expand them
            const newExpandedState = itemParentPathIds.reduce<{
              [key: string]: boolean;
            }>((acc, cur) => ({ ...acc, [cur]: true }), {});
            expandedStore.setExpandedState(newExpandedState);
          }
        }
      }
    }
  }, [expandedStore, items, selectedItemId, ready]);
}
